import axios from "axios";

export const getBrazilianStates = async () => {
  const response = await axios.get(
    "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome");

  return response?.data?.map((state) => ({
    value: state.nome,
    label: state.nome,
    stateId: state.id,
  })) || [];
}

export const getBrazilianCitiesByStateId = async (stateId) => {
  const response = await axios.get(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateId}/municipios?orderBy=nome`);

  return response?.data?.map((city) => ({
    value: city.nome,
    label: city.nome,
  })) || [];
}